import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const HourGlassSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.5 5.5H17.625C17.8125 5.5 18 5.34375 18 5.125V4.375C18 4.1875 17.8125 4 17.625 4H6.375C6.15625 4 6 4.1875 6 4.375V5.125C6 5.34375 6.15625 5.5 6.375 5.5H6.5C6.5 8.03125 7.5 10.6875 9.53125 12C7.46875 13.3438 6.5 16 6.5 18.5H6.375C6.15625 18.5 6 18.6875 6 18.875V19.625C6 19.8438 6.15625 20 6.375 20H17.625C17.8125 20 18 19.8438 18 19.625V18.875C18 18.6875 17.8125 18.5 17.625 18.5H17.5C17.5 16 16.4688 13.3438 14.4375 12C16.5 10.6875 17.5 8.03125 17.5 5.5ZM16 5.5C16 6.40625 15.8438 7.25 15.5938 8H8.375C8.125 7.25 8 6.40625 8 5.5H16ZM15.5938 16H8.375C9.03125 14.0938 10.4062 12.75 12 12.75C13.5625 12.75 14.9375 14.0938 15.5938 16Z"
      fill="#1E252E"
    />
  </svg>
);

const HourGlassIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HourGlassSVG} {...props} />
);

export default HourGlassIcon;
